var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 17.7707H5.83464C3.33464 17.7707 1.66797 16.5207 1.66797 13.604V7.77067C1.66797 4.854 3.33464 3.604 5.83464 3.604H14.168C16.668 3.604 18.3346 4.854 18.3346 7.77067V13.604C18.3346 16.5207 16.668 17.7707 14.168 17.7707Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1875C11.3807 13.1875 12.5 12.0682 12.5 10.6875C12.5 9.30679 11.3807 8.1875 10 8.1875C8.61929 8.1875 7.5 9.30679 7.5 10.6875C7.5 12.0682 8.61929 13.1875 10 13.1875Z",
    stroke: "#3876BB",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 8.18766H2.5013C5.0013 8.18766 5.83464 7.35433 5.83464 4.85433V4.021",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 8.18766H17.5013C15.0013 8.18766 14.168 7.35433 14.168 4.85433V4.021",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 13.1875H2.5013C5.0013 13.1875 5.83464 14.0208 5.83464 16.5208V17.3542",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 13.1875H17.5013C15.0013 13.1875 14.168 14.0208 14.168 16.5208V17.3542",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutsIcon);
export default __webpack_public_path__ + "static/media/PayoutsIcon.e51b2f81515d18ef6a8b641b88a3957f.svg";
export { ForwardRef as ReactComponent };